import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { withTheme } from '../../../theme';
import PropTypes from 'prop-types';
import R from '../../../core-res/R';
import DRNText from '../../../standard/Text/DRNText';
import { getLabelStyle } from '../util/getStyle';
class BottomBar extends Component {
    constructor() {
        super(...arguments);
        this.enforceIconProps = () => {
            const { Icon, theme } = this.props;
            return React.cloneElement(Icon, {
                height: 24,
                width: 24,
                color: theme.brand,
                style: { height: 24, width: 24 },
            });
        };
    }
    render() {
        const { Icon, isActive, theme, activeTabColor, label, smartKey } = this.props;
        const EnforcedIcon = Icon ? this.enforceIconProps() : null;
        return (<View style={styles.container}>
        <View style={styles.iconWrapper}>{!!EnforcedIcon && EnforcedIcon}</View>
        <DRNText style={[styles.label, getLabelStyle(isActive, theme, activeTabColor)]} smartKey={smartKey}>
          {label}
        </DRNText>
      </View>);
    }
}
BottomBar.propTypes = {
    label: PropTypes.string.isRequired,
    theme: PropTypes.object.isRequired,
    isActive: PropTypes.bool.isRequired,
    activeTabColor: PropTypes.string,
    Icon: PropTypes.node,
    smartKey: PropTypes.string,
};
const styles = StyleSheet.create({
    container: {
        padding: R.spacing.xs,
    },
    label: Object.assign({}, R.typography.uiSmall),
    iconWrapper: {
        alignSelf: 'center',
        marginBottom: R.spacing.xxs,
    },
});
export default withTheme(BottomBar);
